import { useCallback } from 'react';

export const usePrintHousing = () => {
  const handlePrint = useCallback(() => {
    const printStyles = `
      @media print {
        header,
        nav,
        footer,
        button:not(.print-keep),
        .no-print,
        [class*="Controls"],
        [class*="Navigation"],
        [class*="ShareModal"],
        [class*="BrokerCompanyCards"],
        [class*="ActionsBox"] button,
        [class*="StyledButton"],
        [class*="ControlsBtn"],
        [class*="ActionsBox"] {
          display: none !important;
        }

        [class*="AsideBrokerInfo"] {
          display: block !important;
          page-break-before: always !important;
          break-before: page !important;
          margin-top: 0 !important;
        }

        [class*="AsideContainer"] {
          max-width: 100% !important;
          padding: 0 !important;
          position: static !important;
        }

        [class*="AsideBox"] {
          max-width: 100% !important;
          position: static !important;
          padding: 20px 24px !important;
          background: #f5f5f5 !important;
          border: 1px solid #ddd !important;
          border-radius: 10px !important;
          margin: 0 !important;
        }

        body {
          font-size: 11pt;
          line-height: 1.6;
          color: #000;
          background: #fff;
          margin: 0;
          padding: 0;
        }

        * {
          border: none !important;
          box-shadow: none !important;
          text-shadow: none !important;
          outline: none !important;
        }

        * {
          background: transparent !important;
          background-image: none !important;
        }

        * {
          color: #000 !important;
        }

        [class*="Container"],
        [class*="Wrapper"] {
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
          border: none !important;
        }

        [class*="ContentCard"] {
          border: none !important;
          padding: 10px 0 !important;
          margin: 0 0 15px 0 !important;
          box-shadow: none !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        [class*="ContentCard"]:has(h1, h2, h3, h4, h5, h6) {
          page-break-before: avoid !important;
          break-before: avoid !important;
        }

        [class*="MainColsWrap"] {
          flex-direction: column !important;
          gap: 15px !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        [class*="MainColContainer"] {
          gap: 20px !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        p, div, span, li {
          line-height: 1.6 !important;
          margin: 0 0 8px 0 !important;
          padding: 0 !important;
        }

        h1, h2, h3, h4, h5, h6 {
          margin: 12px 0 8px 0 !important;
          padding: 0 !important;
          page-break-after: avoid !important;
          break-after: avoid !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          line-height: 1.4 !important;
        }

        h1 + *, h2 + *, h3 + *, h4 + *, h5 + *, h6 + * {
          page-break-before: avoid !important;
          break-before: avoid !important;
        }

        [class*="ContentCard"] > h1,
        [class*="ContentCard"] > h2,
        [class*="ContentCard"] > h3,
        [class*="ContentCard"] > h4,
        [class*="ContentCard"] > h5,
        [class*="ContentCard"] > h6 {
          page-break-after: avoid !important;
          break-after: avoid !important;
        }

        ul, ol {
          margin: 8px 0 !important;
          padding-left: 20px !important;
        }

        li {
          margin: 4px 0 !important;
          padding: 0 !important;
        }

        img {
          max-width: 100% !important;
          height: auto !important;
          page-break-inside: avoid;
          break-inside: avoid;
          margin: 8px 0 !important;
        }

        [class*="Gallery"] {
          margin: 10px 0 !important;
          padding: 0 !important;
        }

        [class*="Gallery"] img {
          max-width: 100% !important;
          page-break-inside: avoid;
        }

        [class*="QuickInfo"] {
          border: none !important;
          padding: 10px 0 !important;
          margin: 0 !important;
        }

        [class*="Description"] {
          margin: 15px 0 !important;
          padding: 0 !important;
        }

        [class*="DetailedInformation"] {
          margin: 15px 0 !important;
          padding: 0 !important;
        }

        [class*="Map"] {
          page-break-inside: avoid;
          margin: 10px 0 !important;
        }

        [class*="FileList"] {
          page-break-inside: avoid;
          margin: 10px 0 !important;
        }

        [class*="TitleBox"] {
          margin: 0 0 10px 0 !important;
          padding: 0 !important;
        }

        [class*="AddressBox"] {
          margin: 5px 0 !important;
          padding: 0 !important;
        }

        [class*="TextBox"] {
          max-height: none !important;
          height: auto !important;
          overflow: visible !important;
          transition: none !important;
        }

        [class*="AccordionContent"] {
          max-height: none !important;
          height: auto !important;
          overflow: visible !important;
          padding: 6px 12px !important;
          border-top: 1px solid #ccc !important;
          display: block !important;
          transition: none !important;
        }

        div[style*="max-height"],
        div[style*="overflow: hidden"] {
          max-height: none !important;
          overflow: visible !important;
        }

        [class*="ExpandTextIcon"],
        button[onclick*="setIsExpanded"],
        [class*="AccordionHeader"],
        p[style*="cursor: pointer"],
        div[style*="cursor: pointer"] {
          display: none !important;
        }

        * {
          clip: auto !important;
          clip-path: none !important;
        }

        a {
          color: #000 !important;
          text-decoration: underline !important;
        }

        a[href^="http"]:after {
          content: " (" attr(href) ")";
          font-size: 0.85em;
        }

        [class*="QuickInfo"],
        [class*="Description"],
        [class*="DetailedInformation"],
        [class*="ContentCard"] {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        [class*="SendRequestForm"],
        [class*="AgentData"] {
          display: block !important;
        }

        .MuiTextField-root {
          margin-bottom: 12px !important;
          width: 100% !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        .MuiInputLabel-root {
          position: static !important;
          transform: none !important;
          margin-bottom: 4px !important;
          display: block !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #000 !important;
          line-height: 1.5 !important;
          page-break-after: avoid !important;
          break-after: avoid !important;
        }

        .MuiTextField-root,
        .MuiFormControl-root {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        .MuiInputLabel-root + .MuiInputBase-root,
        .MuiInputLabel-root + * {
          page-break-before: avoid !important;
          break-before: avoid !important;
        }

        .MuiInputBase-root {
          margin-top: 0 !important;
          padding: 0 !important;
        }

        .MuiInputBase-input,
        .MuiOutlinedInput-input,
        .MuiInput-input {
          border: 1px solid #ccc !important;
          background: #fff !important;
          padding: 10px 14px !important;
          margin: 0 !important;
          width: 100% !important;
          box-sizing: border-box !important;
          font-size: 14px !important;
          line-height: 1.5 !important;
          min-height: 40px !important;
        }

        .MuiOutlinedInput-root {
          border: 1px solid #ccc !important;
          background: #fff !important;
          padding: 0 !important;
        }

        .MuiOutlinedInput-notchedOutline {
          border: 1px solid #ccc !important;
        }

        textarea.MuiInputBase-input {
          min-height: 80px !important;
          padding: 10px 14px !important;
        }

        input:not(.MuiInputBase-input),
        textarea:not(.MuiInputBase-input),
        select:not(.MuiSelect-select) {
          border: 1px solid #ccc !important;
          background: #fff !important;
          padding: 10px 14px !important;
          margin: 4px 0 !important;
          width: 100% !important;
          box-sizing: border-box !important;
          font-size: 14px !important;
          min-height: 40px !important;
        }

        label:not(.MuiInputLabel-root) {
          display: block !important;
          margin: 8px 0 4px 0 !important;
          font-weight: 500 !important;
          font-size: 14px !important;
        }

        input[type="checkbox"] {
          width: auto !important;
          margin-right: 8px !important;
          height: 18px !important;
          width: 18px !important;
        }

        .MuiSelect-root {
          border: 1px solid #ccc !important;
          background: #fff !important;
          padding: 10px 14px !important;
          min-height: 40px !important;
        }

        .MuiSelect-select {
          padding: 10px 14px !important;
        }

        .MuiSelect-icon,
        .MuiSelect-iconOpen,
        .MuiOutlinedInput-notchedOutline + svg,
        .MuiSelect-root svg,
        .MuiSelect-root .MuiSvgIcon-root,
        .MuiInputBase-root svg,
        .MuiOutlinedInput-root svg,
        .MuiSelect-root .MuiSvgIcon-root,
        [class*="Select"] svg,
        [class*="Select"] .MuiSvgIcon-root {
          display: none !important;
          visibility: hidden !important;
        }

        [class*="SendRequestForm"] .MuiDivider-root,
        [class*="SendRequestForm"] hr,
        [class*="SendRequestForm"] .MuiDivider-root + *,
        .MuiDivider-root:has(span),
        .MuiDivider-root:has(> span),
        .MuiDivider-root:has(> * > span) {
          display: none !important;
        }

        [class*="SendRequestForm"] button,
        [class*="AgentStyledButton"] {
          border: 1px solid #ccc !important;
          background: #fff !important;
          padding: 10px 20px !important;
          margin: 8px 4px 8px 0 !important;
          display: inline-block !important;
          color: #000 !important;
          cursor: default !important;
        }

        [class*="Wrapper"]:has([class*="SendRequestForm"]) {
          width: 100% !important;
        }

        [class*="LineWrapper"],
        [class*="LineWrapperDouble"],
        [class*="CheckboxLineWrapper"] {
          margin: 0 0 12px 0 !important;
          display: flex !important;
          gap: 15px !important;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        [class*="LineWrapper"]:not([class*="Double"]):not([class*="Checkbox"]) {
          flex-direction: column !important;
        }

        [class*="LineWrapperDouble"] {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 15px !important;
        }

        [class*="CheckboxLineWrapper"] {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 10px !important;
        }

        [class*="LineWrapperDouble"] .MuiTextField-root {
          width: 100% !important;
        }

        [class*="LineWrapper"] > *,
        [class*="LineWrapperDouble"] > * {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
        }

        hr, [class*="Divider"] {
          border-top: 1px solid #ccc !important;
          margin: 12px 0 !important;
        }

        p, div, span {
          orphans: 3;
          widows: 3;
        }

        h1, h2, h3, h4, h5, h6 {
          orphans: 2;
          widows: 2;
        }

        [class*="ContentCard"] > *:first-child {
          page-break-after: avoid !important;
        }

        @page {
          margin: 0.8cm;
        }
      }
    `;

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.id = 'print-styles';
    styleSheet.innerText = printStyles;

    const existingStyle = document.getElementById('print-styles');
    if (existingStyle) {
      existingStyle.remove();
    }

    document.head.appendChild(styleSheet);

    setTimeout(() => {
      window.print();

      setTimeout(() => {
        const styleToRemove = document.getElementById('print-styles');
        if (styleToRemove) {
          styleToRemove.remove();
        }
      }, 1000);
    }, 100);
  }, []);

  return { handlePrint };
};
